import { render, staticRenderFns } from "./specialEqus.vue?vue&type=template&id=3247196a&scoped=true&"
import script from "./specialEqus.vue?vue&type=script&lang=js&"
export * from "./specialEqus.vue?vue&type=script&lang=js&"
import style0 from "./specialEqus.vue?vue&type=style&index=0&id=3247196a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247196a",
  null
  
)

export default component.exports